var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 1V2C11.55 2 12 2.45 12 3V5C12 5.55 11.55 6 11 6V12C11 12.55 10.55 13 10 13H4C3.45 13 3 12.55 3 12V6C2.45 6 2 5.55 2 5V3C2 2.45 2.45 2 3 2V1C3 0.45 3.45 0 4 0H10C10.55 0 11 0.45 11 1ZM9 6H5V11H9V6Z",
    fill: "#212D41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 15.1046 0.895431 16 2 16L12 16C13.1046 16 14 15.1046 14 14V7C14 6.44771 13.5523 6 13 6C12.4477 6 12 6.44771 12 7V14L2 14L2 7C2 6.44771 1.55228 6 1 6C0.447715 6 0 6.44771 0 7V14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.201bd43f4c0c5aa4548f47ea665ef6ae.svg";
export { ForwardRef as ReactComponent };